import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { CurrencyProvider } from '@/contexts/CurrencyContext';
import TrackingPixels from '@/components/TrackingPixels';
import HomePage from '@/pages/HomePage';
import ProductsPage from '@/pages/ProductsPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import CartPage from '@/pages/CartPage';
import CheckoutPage from '@/pages/CheckoutPage';
import OrderSuccessPage from '@/pages/OrderSuccessPage';
import OrderCompletePage from '@/pages/OrderCompletePage';
import UserDashboard from '@/pages/UserDashboard';
import AdminDashboardEnhanced from '@/pages/AdminDashboardEnhanced';
import TrackingPage from '@/pages/TrackingPage';
import CollectionPage from '@/pages/CollectionPage';
import ProductGalleryPage from '@/pages/ProductGalleryPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsConditionsPage from '@/pages/TermsConditionsPage';
import AboutUsPage from '@/pages/AboutUsPage';
import PrivateRoute from '@/components/PrivateRoute';
import LiveChatWidget from '@/components/LiveChatWidget';
import WhatsAppWidget from '@/components/WhatsAppWidget';
import ReferralTracker from '@/components/ReferralTracker';
import AffiliateDashboard from '@/pages/AffiliateDashboard';

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <CartProvider>
          <div className="App">
            <BrowserRouter>
              <TrackingPixels />
              <ReferralTracker />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/collections/:slug" element={<CollectionPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-success" element={<OrderSuccessPage />} />
                <Route path="/order-complete/:orderId" element={<OrderCompletePage />} />
                <Route path="/tracking/:orderId" element={<TrackingPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/dashboard" element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
                <Route path="/affiliate" element={<PrivateRoute><AffiliateDashboard /></PrivateRoute>} />
                <Route path="/admin" element={<PrivateRoute requireAdmin={true}><AdminDashboardEnhanced /></PrivateRoute>} />
                <Route path="/admin/gallery" element={<PrivateRoute requireAdmin={true}><ProductGalleryPage /></PrivateRoute>} />
              </Routes>
              <LiveChatWidget />
              <WhatsAppWidget />
              <Toaster position="top-right" />
            </BrowserRouter>
          </div>
        </CartProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
